module.exports = __webpack_public_path__ + "img/DNADamage-BRCA_10X_Section2.8d58987f.png";